import { Navigate, Outlet } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const PublicRoutes: React.FC = () => {
  const isAuth = useAuth()

  return !isAuth ? <Outlet /> : <Navigate to='/cases/inbox' replace />
}

export default PublicRoutes
